module.exports = __webpack_public_path__ + "static/DSC_9380-3e1d5ca016e21bbddca0fd381c64839a.jpg";